<ng-container *ngIf="!showTicketList">
  <form [formGroup]="form">
    <div class="form-group">
      <label for="amount">{{ 'fgbcl.ticket.invite.email.label' | translate }}</label>
      <input
        type="email"
        formControlName="email"
        class="form-control"
        [ngClass]="{ 'is-invalid': (f['email'].invalid && f['email'].touched) || (f['email'].invalid && submitted) }"
      />
      <div *ngIf="(f['email'].invalid && f['email'].touched) || (f['email'].invalid && submitted)" class="invalid-feedback">
        <div *ngIf="f.email?.errors?.required">{{ 'fgbcl.ticket.invite.email.required.error' | translate }}</div>
        <div *ngIf="f.email?.errors?.pattern">{{ 'fgbcl.ticket.invite.email.pattern.error' | translate }}</div>
      </div>
    </div>
    <div class="form-group">
      <label for="uniquecode">{{ 'fgbcl.ticket.invite.uniquecode.label' | translate }}</label>
      <input
        type="text"
        formControlName="uniqueCode"
        class="form-control"
        [ngClass]="{
          'is-invalid': (f['uniqueCode'].invalid && f['uniqueCode'].touched) || (f['uniqueCode'].invalid && submitted)
        }"
      />
      <div
        *ngIf="(f['uniqueCode'].invalid && f['uniqueCode'].touched) || (f['uniqueCode'].invalid && submitted)"
        class="invalid-feedback"
      >
        <div *ngIf="f.uniqueCode?.errors?.required">
          {{ 'fgbcl.ticket.invite.uniquecode.required.error' | translate }}
        </div>
      </div>
    </div>
  </form>
  <div class="mb-2 text-danger" *ngIf="!validateCredentials">
    {{ codeErrorKey | translate }}
  </div>

  <div class="text-center">
    <button (click)="onSubmit()" class="btn btn-primary py-2 px-5">
      {{ 'ticket.invite.credentials.validation.submit.button' | translate }}
    </button>
  </div>
</ng-container>

<ng-container *ngIf="showTicketList">
  <ng-container *ngFor="let ticket of ticketInvideList">
    <fgbcl-ticket-invite-list [ticketInvite]="ticket"></fgbcl-ticket-invite-list>
  </ng-container>
  <div class="my-2 text-danger" *ngIf="!ticketInviteProcess">
    {{ codeErrorKey | translate }}
  </div>
  <div class="text-center mt-3">
    <button class="btn btn-primary py-2 px-5" (click)="ticketProcess()">{{ 'ticket.invite.process.button' | translate }}</button>
  </div>
</ng-container>
